__turbopack_context__.v({
  "component": "style-module-scss-module__fajyrW__component",
  "component-full-width": "style-module-scss-module__fajyrW__component-full-width",
  "icon": "style-module-scss-module__fajyrW__icon",
  "label-left": "style-module-scss-module__fajyrW__label-left",
  "switch": "style-module-scss-module__fajyrW__switch",
});
